/*
 * @Author: randy
 * @Date: 2020-07-31 12:56:31
 * @LastEditTime: 2020-08-25 10:11:50
 * @Description: type
 */
export const ACCESS_TOKEN = "ACCESS_TOKEN";
export const USER = "USER";
export const BASE = "BASE";
export const SET_TOKEN = "SET_TOKEN";
export const SET_USER = "SET_USER";
export const SET_BASE = "SET_BASE";
export const SET_PERMISSIONS = "SET_PERMISSIONS";
export const SET_COLLAPSED = "SET_COLLAPSED";
export const SET_MOBILE = "SET_MOBILE";
export const SET_PAD = "SET_PAD";
export const SET_DRAWER = "SET_DRAWER";
export const ADD_HISTORY_TAG = "ADD_HISTORY_TAG";
export const REMOVE_HISTORY_TAG = "REMOVE_HISTORY_TAG";
export const REMOVE_OTHER_TAG = "REMOVE_OTHER_TAG";
export const REMOVE_ALL_TAG = "REMOVE_ALL_TAG";
export const CLEAR_ALL_TAG = "CLEAR_ALL_TAG";
export const SET_PLAYING = "SET_PLAYING";
export const SET_ADD_ROUTES = "SET_ADD_ROUTES";
export const SET_ROUTES = "SET_ROUTES";
export const SET_DEFAULT_ROUTE_PATH = "SET_DEFAULT_ROUTE_PATH";
export const SET_PRIMAY_COLOR = "SET_PRIMAY_COLOR";
